import React from 'react'
import { ZoomControl as LeafletZoomControl } from 'react-leaflet'
import { useTranslation } from 'utils/useTranslation'

export type ZoomControlProps = {
  isActive?: boolean
}

export const ZoomControl: React.FC<ZoomControlProps> = ({ isActive }) => {
  const { t } = useTranslation('components.map')

  if (!isActive) {
    return null
  }

  return <LeafletZoomControl zoomInTitle={t('zoomin')} zoomOutTitle={t('zoomout')} />
}
